var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4373 3.54098L15.3981 3.58046L13.9501 2.11993L13.9894 2.08046C14.3686 1.67704 15.0004 1.66026 15.4001 2.04296C15.4128 2.05519 15.4251 2.06763 15.4373 2.08046C15.8299 2.48664 15.8299 3.1346 15.4373 3.54098V3.54098ZM9.78291 9.24493L7.86552 9.73835L8.33508 7.80414L12.8351 3.22519L14.2829 4.68572L9.78291 9.24493ZM16.5329 0.955456C15.5192 -0.0554647 13.8879 -0.0554647 12.874 0.955456L7.0829 6.83704C6.98234 6.93493 6.90819 7.0573 6.86769 7.1923L6.02638 10.6462C5.94832 10.9135 6.02384 11.2022 6.22203 11.3962C6.37132 11.5498 6.57616 11.6355 6.78942 11.6331L6.96551 11.5936L10.3894 10.725C10.5219 10.6914 10.6432 10.6235 10.7416 10.5278L16.5525 4.64625C17.5491 3.61815 17.5403 1.97269 16.5329 0.955456V0.955456Z",
    fill: "#97AFCE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.391602,
    y: 12.7383,
    width: 15.6522,
    height: 1.57895,
    rx: 0.789474,
    fill: "#97AFCE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dd436839.svg";
export { ForwardRef as ReactComponent };